import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MuiDialog from '@mui/material/Dialog';
import { useIntl } from '@mfw/components';
import Button from '@mui/material/Button';

import { useNavigate } from '../../../router/hooks';
import messages from './messages';

export interface PostExitOfferDialogProps {
  onClose: () => void;
  open: boolean;
}

// F9 — shown after a successful leave/close once the user no longer has an
// ACTIVE OWNER/TRAINER relation to any organization. Content transfer is
// NOT possible from here (the org is already gone/left) — this only offers
// a link to create a new profile.
export const PostExitOfferDialog = ({
  onClose,
  open,
}: PostExitOfferDialogProps) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleAddProfile = () => {
    onClose();
    navigate('/profiles/new');
  };

  return (
    <MuiDialog
      data-testid="post-exit-offer-dialog"
      onClose={onClose}
      maxWidth="xs"
      open={open}
      fullWidth
    >
      <DialogTitle>{formatMessage(messages.postExitOfferTitle)}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {formatMessage(messages.postExitOfferDescription)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button data-testid="post-exit-offer-dismiss" onClick={onClose}>
          {formatMessage(messages.postExitOfferDismiss)}
        </Button>
        <Button
          data-testid="post-exit-offer-add-profile"
          onClick={handleAddProfile}
          variant="contained"
        >
          {formatMessage(messages.postExitOfferAddProfile)}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default PostExitOfferDialog;
